import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from './firebaseConfig';
import Homepage from './Homepage';
import Dashboard from './Dashboard';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
          Agreedly
        </Typography>
      </Box>
    );
  }

  if (user) {
    // Conteúdo para usuários autenticados
    return <Dashboard />;
  } else {
    // Conteúdo da homepage
    return <Homepage />;
  }
};

export default App;